import { Toast } from "@8x8/oxygen-toast";
import React from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { REACT_APP_ID } from "@/react/routing/constants";
import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  top: 80px;
  left: 50%;
`;

export const ConfirmMessage = ({
  handleInfirm,
  handleConfirm,
  question,
  title,
  type,
}) => {
  return createPortal(
    <Container>
      <Toast
        title={title}
        description={question}
        actions={[
          { title: "No", callback: handleInfirm, id: 1 },
          { title: "Yes", callback: handleConfirm, id: 2 },
        ]}
        onCloseControlClick={handleInfirm}
        type={type}
      />
    </Container>,
    document.getElementById(REACT_APP_ID)
  );
};
ConfirmMessage.defaultProps = {
  type: "success",
};
ConfirmMessage.propTypes = {
  type: PropTypes.oneOf(["success", "warning", "error", "info"]),
};
